<table mat-table [dataSource]="dataSource" matSort matSortDisableClear class="w-100">

  <ng-container matColumnDef="value">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Recipient</th>
    <td mat-cell *matCellDef="let element"> {{element.value.toLowerCase()}} </td>
  </ng-container>

  <ng-container matColumnDef="deliveryType">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Type</th>
    <td mat-cell *matCellDef="let element"> {{element.deliveryType}} </td>
  </ng-container>

  <ng-container matColumnDef="format">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Format</th>
    <td mat-cell *matCellDef="let element"> {{element.format}} </td>
  </ng-container>

  <ng-container matColumnDef="userRacf">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Username</th>
    <td mat-cell *matCellDef="let element"> {{element.userRacf.toUpperCase()}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status</th>
    <td mat-cell *matCellDef="let element">
      <ns-status [status]="element.status ? element.status.toLowerCase() : 'inactive'"></ns-status>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr mat-row *matRowDef="let row; columns: columns;"></tr>
</table>
